import React,{useState,useEffect} from 'react'
import {Table} from "reactstrap";
import {selfSales} from 'network/ApiAxiosTickets'
import { reportTodayTicketsBySeller } from 'network/ApiAxiosTickets';


function DaySalesBySeller() {
    const [deposits, setDeposits] = useState({});
    useEffect(() => {
        getTotalTicketsList()
    }, []);

    const getTotalTicketsList =async()=>{
        const {data} = await reportTodayTicketsBySeller()
        if(data.success){
            console.log(data)
            setDeposits(data)
        }
    }
  return (
    <Table className="text-white" responsive>
        <thead>
            <tr>
                <th>
                    Event
                </th>
                <th>
                    Tickets
                </th>
            </tr>
        </thead>
        <tbody>
        {deposits.totals && Object.keys(deposits.totals).map((row)=>{
            return <><tr key={row[0]}>
                        <th scope="col" className=' text-wrap ml-0 pl-0'>
                            <h3 className=' text-white'>{row}</h3>
                        </th>
                        <th scope="col">
                            <h3 className=' text-white'>
                                {Object.entries(deposits.totals[row]).reduce((acc, value) => {
                                    return acc + value[1];
                                }, 0)}
                            </h3>
                        </th>
                    </tr>
                    {Object.entries(deposits.totals[row]).map((event)=>{
                        return <tr key={event[0]}>
                                    <th scope="col" className=' text-wrap'>
                                        <h6 className=' text-white'>{event[0]}</h6>
                                    </th>
                                    <th scope="col">
                                        {event[1]}
                                    </th>
                                </tr>
                    })}
                    </>
        })}
        </tbody>
    </Table>
  )
}

export default DaySalesBySeller